import FirstBanner from './first-banner.vue'
import ThirdBanner from './third-banner.vue'
export default {
	FirstBanner,
	ThirdBanner
}